<template>
<div class="payments" v-if="items" data-scroll-lock-scrollable>
	<table class="payments__table">
		<tbody>
			<tr class="payments__row" v-for="payment in items" :key="payment.id">
				<td>
					<span class="payments__amount">id: {{ payment.id }}</span>
				</td>
				<td class="payments__id-td" v-if="payment.wallet">
					<div class="payments__id">{{ payment.wallet }}</div>
				</td>
				<td>
					<span class="payments__amount">{{ payment.amount }}₽</span>
				</td>
				<td class="payments__info-td">
					<div class="payments__info">
						<div class="payments__merchant">{{ payment.type }}</div>
						<div class="payments__date">{{ payment.date }}</div>
					</div>
				</td>
				<td>
					<span class="payments__status" :class="'payments__status--' + payment.status">
						<svg class="payments__status-icon">
							<use href="#svg-icon-close" v-if="payment.status === 'canceled' || payment.status === 'failed'"></use>
							<use href="#svg-icon-time" v-else-if="payment.status === 'performed' || payment.status === 'pending' || payment.status === 'deferred'"></use>
							<use href="#svg-icon-check" v-else></use>
						</svg>
					</span>
				</td>
			</tr>
		</tbody>
	</table>
</div>

</template>

<script>

export default {
	props: {
		items: {
			type: Array,
			default: null
		}
	}
}

</script>